import { render, staticRenderFns } from "./users_admin_page.vue?vue&type=template&id=7fc7c253&scoped=true"
import script from "./users_admin_page.vue?vue&type=script&lang=js"
export * from "./users_admin_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc7c253",
  null
  
)

export default component.exports